import BannerSection from '../components/sections/home/BannerSection';
import CoreValueSection from '../components/sections/home/CoreValueSection';
import TargetCustomerSection from '../components/sections/home/TargetCustomerSection';
import ReviewSection from '../components/sections/home/ReviewSection';
import TeacherSection from '../components/sections/home/TeacherSection';

export default function HomePage() {
  return (
    <div className="min-h-screen mx-auto">
      <BannerSection />
      <CoreValueSection />
      <TeacherSection />
      <TargetCustomerSection />
      <ReviewSection />
    </div>
  );
} 